// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CompactValueStats_card__2qdbV {
  width: 122px;
  padding: 10px 9px;
  border: 1px solid #d8e0e5;
  border-radius: 8px;
  background: rgba(255, 255, 255, 0.98);
  box-shadow: 0 6px 18px rgba(26, 54, 72, 0.2);
  color: #17384c;
}

.CompactValueStats_title__zj-mf {
  display: block;
  margin-bottom: 9px;
  font-size: 10px;
  line-height: 1.1;
  text-align: center;
  text-transform: uppercase;
  letter-spacing: 0.02em;
}

.CompactValueStats_grid__JkqO- {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 9px 8px;
}

.CompactValueStats_metric__GBE6H {
  min-width: 0;
  text-align: center;
}

.CompactValueStats_iconBox__dfKM5 {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  margin: 0 auto 4px;
  border: 1px solid currentColor;
  border-radius: 9px;
  background: color-mix(in srgb, currentColor 10%, white);
}

.CompactValueStats_iconBox__dfKM5 img {
  width: 25px;
  height: 25px;
}

.CompactValueStats_progressTrack__6170b {
  width: 40px;
  height: 5px;
  margin: 0 auto 4px;
  overflow: hidden;
  border-radius: 999px;
  background: #e8eaec;
}

.CompactValueStats_progressTrack__6170b span {
  display: block;
  height: 100%;
  border-radius: inherit;
  background: currentColor;
}

.CompactValueStats_percentage__3RdUY {
  display: block;
  color: #243746;
  font-size: 10px;
  font-weight: 700;
  line-height: 1;
}

.CompactValueStats_bienveillance__k1Rny {
  color: var(--upcare-value-bienveillance, #fed14c);
}

.CompactValueStats_engagement__DzX1N {
  color: var(--upcare-value-engagement, #2894d2);
}

.CompactValueStats_faireEquipe__a\\+7yI {
  color: var(--upcare-value-faire-equipe, #e71873);
}

.CompactValueStats_respect__GXL5C {
  color: var(--upcare-value-respect, #2fac68);
}

@media (max-width: 760px) {
  .CompactValueStats_card__2qdbV {
    width: 108px;
    padding: 8px 7px;
  }

  .CompactValueStats_iconBox__dfKM5 {
    width: 32px;
    height: 32px;
  }

  .CompactValueStats_iconBox__dfKM5 img {
    width: 22px;
    height: 22px;
  }

  .CompactValueStats_progressTrack__6170b {
    width: 34px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Overview/CompactValueStats.module.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,qCAAqC;EACrC,4CAA4C;EAC5C,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,8BAA8B;EAC9B,kBAAkB;EAClB,uDAAuD;AACzD;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,sBAAsB;EACtB,wBAAwB;AAC1B;;AAEA;EACE,cAAc;EACd,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,iDAAiD;AACnD;;AAEA;EACE,8CAA8C;AAChD;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE;IACE,YAAY;IACZ,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,WAAW;EACb;AACF","sourcesContent":[".card {\r\n  width: 122px;\r\n  padding: 10px 9px;\r\n  border: 1px solid #d8e0e5;\r\n  border-radius: 8px;\r\n  background: rgba(255, 255, 255, 0.98);\r\n  box-shadow: 0 6px 18px rgba(26, 54, 72, 0.2);\r\n  color: #17384c;\r\n}\r\n\r\n.title {\r\n  display: block;\r\n  margin-bottom: 9px;\r\n  font-size: 10px;\r\n  line-height: 1.1;\r\n  text-align: center;\r\n  text-transform: uppercase;\r\n  letter-spacing: 0.02em;\r\n}\r\n\r\n.grid {\r\n  display: grid;\r\n  grid-template-columns: repeat(2, 1fr);\r\n  gap: 9px 8px;\r\n}\r\n\r\n.metric {\r\n  min-width: 0;\r\n  text-align: center;\r\n}\r\n\r\n.iconBox {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  width: 36px;\r\n  height: 36px;\r\n  margin: 0 auto 4px;\r\n  border: 1px solid currentColor;\r\n  border-radius: 9px;\r\n  background: color-mix(in srgb, currentColor 10%, white);\r\n}\r\n\r\n.iconBox img {\r\n  width: 25px;\r\n  height: 25px;\r\n}\r\n\r\n.progressTrack {\r\n  width: 40px;\r\n  height: 5px;\r\n  margin: 0 auto 4px;\r\n  overflow: hidden;\r\n  border-radius: 999px;\r\n  background: #e8eaec;\r\n}\r\n\r\n.progressTrack span {\r\n  display: block;\r\n  height: 100%;\r\n  border-radius: inherit;\r\n  background: currentColor;\r\n}\r\n\r\n.percentage {\r\n  display: block;\r\n  color: #243746;\r\n  font-size: 10px;\r\n  font-weight: 700;\r\n  line-height: 1;\r\n}\r\n\r\n.bienveillance {\r\n  color: var(--upcare-value-bienveillance, #fed14c);\r\n}\r\n\r\n.engagement {\r\n  color: var(--upcare-value-engagement, #2894d2);\r\n}\r\n\r\n.faireEquipe {\r\n  color: var(--upcare-value-faire-equipe, #e71873);\r\n}\r\n\r\n.respect {\r\n  color: var(--upcare-value-respect, #2fac68);\r\n}\r\n\r\n@media (max-width: 760px) {\r\n  .card {\r\n    width: 108px;\r\n    padding: 8px 7px;\r\n  }\r\n\r\n  .iconBox {\r\n    width: 32px;\r\n    height: 32px;\r\n  }\r\n\r\n  .iconBox img {\r\n    width: 22px;\r\n    height: 22px;\r\n  }\r\n\r\n  .progressTrack {\r\n    width: 34px;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"card": `CompactValueStats_card__2qdbV`,
	"title": `CompactValueStats_title__zj-mf`,
	"grid": `CompactValueStats_grid__JkqO-`,
	"metric": `CompactValueStats_metric__GBE6H`,
	"iconBox": `CompactValueStats_iconBox__dfKM5`,
	"progressTrack": `CompactValueStats_progressTrack__6170b`,
	"percentage": `CompactValueStats_percentage__3RdUY`,
	"bienveillance": `CompactValueStats_bienveillance__k1Rny`,
	"engagement": `CompactValueStats_engagement__DzX1N`,
	"faireEquipe": `CompactValueStats_faireEquipe__a+7yI`,
	"respect": `CompactValueStats_respect__GXL5C`
};
export default ___CSS_LOADER_EXPORT___;
